var fluxCompatibility = {};

fluxCompatibility.init = function () {
    this.compatSalesBooster();
    this.ie11PasswordStrength();
    this.compatDeliverySlots();
};

/**
 * Add compatibility with Sales Booster.
 */
fluxCompatibility.compatSalesBooster = function () {
    Array.from(document.querySelectorAll('[data-iconic-wsb-checkout-bump-trigger]')).forEach(function (checkbox) {
        checkbox.addEventListener('change', function () {
            jQuery('[data-iconic-wsb-checkout-bump-trigger]').trigger('change');
        });
    });
};

fluxCompatibility.compatDeliverySlots = function () {
    // setTimeOut because we want our event listener to run after wc_checkout_form::validate_field().
    window.setTimeout( function () {
        jQuery( '#jckwds-delivery-date, #jckwds-delivery-time' ).on( 'validate', function ( e ) {
            if ( '1' === jQuery( '[name=iconic-wds-fields-hidden]' ).val() ) {
                jQuery( e.target ).closest( '.form-row' ).removeClass( 'woocommerce-invalid' );
                e.stopPropagation();
            }
        } );
    } );
};

/**
 *  IE11 Compatibility.
 */ 
if (!('remove' in Element.prototype)) {
    Element.prototype.remove = function () {
        if (this.parentNode) {
            this.parentNode.removeChild(this);
        }
    };
}

if (!Array.from) {
    Array.from = (function () {
        var toStr = Object.prototype.toString;
        var isCallable = function (fn) {
            return typeof fn === 'function' || toStr.call(fn) === '[object Function]';
        };
        var toInteger = function (value) {
            var number = Number(value);
            if (isNaN(number)) {
                return 0;
            }
            if (number === 0 || !isFinite(number)) {
                return number;
            }
            return (number > 0 ? 1 : -1) * Math.floor(Math.abs(number));
        };
        var maxSafeInteger = Math.pow(2, 53) - 1;
        var toLength = function (value) {
            var len = toInteger(value);
            return Math.min(Math.max(len, 0), maxSafeInteger);
        };

        // The length property of the from method is 1.
        return function from(arrayLike /*, mapFn, thisArg */ ) {
            // 1. Let C be the this value.
            var C = this;

            // 2. Let items be ToObject(arrayLike).
            var items = Object(arrayLike);

            // 3. ReturnIfAbrupt(items).
            if (arrayLike == null) {
                throw new TypeError("Array.from requires an array-like object - not null or undefined");
            }

            // 4. If mapfn is undefined, then let mapping be false.
            var mapFn = arguments.length > 1 ? arguments[1] : void undefined;
            var T;
            if (typeof mapFn !== 'undefined') {
                // 5. else
                // 5. a If IsCallable(mapfn) is false, throw a TypeError exception.
                if (!isCallable(mapFn)) {
                    throw new TypeError('Array.from: when provided, the second argument must be a function');
                }

                // 5. b. If thisArg was supplied, let T be thisArg; else let T be undefined.
                if (arguments.length > 2) {
                    T = arguments[2];
                }
            }

            // 10. Let lenValue be Get(items, "length").
            // 11. Let len be ToLength(lenValue).
            var len = toLength(items.length);

            // 13. If IsConstructor(C) is true, then
            // 13. a. Let A be the result of calling the [[Construct]] internal method of C with an argument list containing the single item len.
            // 14. a. Else, Let A be ArrayCreate(len).
            var A = isCallable(C) ? Object(new C(len)) : new Array(len);

            // 16. Let k be 0.
            var k = 0;
            // 17. Repeat, while k < len… (also steps a - h)
            var kValue;
            while (k < len) {
                kValue = items[k];
                if (mapFn) {
                    A[k] = typeof T === 'undefined' ? mapFn(kValue, k) : mapFn.call(T, kValue, k);
                } else {
                    A[k] = kValue;
                }
                k += 1;
            }
            // 18. Let putStatus be Put(A, "length", len, true).
            A.length = len;
            // 20. Return A.
            return A;
        };
    }());
}

if (!Element.prototype.matches) {
    Element.prototype.matches = Element.prototype.msMatchesSelector ||
        Element.prototype.webkitMatchesSelector;
}

if (!Element.prototype.closest) {
    Element.prototype.closest = function (s) {
        var el = this;

        do {
            if (Element.prototype.matches.call(el, s)) { return el; }
            el = el.parentElement || el.parentNode;
        } while (el !== null && el.nodeType === 1);
        return null;
    };
}

if (!Object.entries) {
    Object.entries = function (obj) {
        var ownProps = Object.keys(obj),
            i = ownProps.length,
            resArray = new Array(i); // preallocate the Array
        while (i--) {
            resArray[i] = [ownProps[i], obj[ownProps[i]]];
        }

        return resArray;
    };
}

if (!String.prototype.includes) {
    String.prototype.includes = function (search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }

        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}

if (!Array.prototype.includes) {
    Object.defineProperty(Array.prototype, "includes", {
        enumerable: false,
        value: function (obj) {
            var newArr = this.filter(function (el) {
                return el === obj;
            });
            return newArr.length > 0;
        }
    });
}

(function (arr) {
    arr.forEach(function (item) {
        if (item.hasOwnProperty('prepend')) {
            return;
        }
        Object.defineProperty(item, 'prepend', {
            configurable: true,
            enumerable: true,
            writable: true,
            value: function prepend() {
                var argArr = Array.prototype.slice.call(arguments),
                    docFrag = document.createDocumentFragment();

                argArr.forEach(function (argItem) {
                    var isNode = argItem instanceof Node;
                    docFrag.appendChild(isNode ? argItem : document.createTextNode(String(argItem)));
                });

                this.insertBefore(docFrag, this.firstChild);
            }
        });
    });
})([Element.prototype, Document.prototype, DocumentFragment.prototype]);

(function () {

    if (typeof window.CustomEvent === "function") { return false; }

    function CustomEvent(event, params) {
        params = params || {
            bubbles: false,
            cancelable: false,
            detail: null
        };
        var evt = document.createEvent('CustomEvent');
        evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
        return evt;
    }

    window.CustomEvent = CustomEvent;
})();

/**
 * Add support for IE11 password strength.
 */
fluxCompatibility.ie11PasswordStrength = function() {
    if ( 'undefined' === typeof wp ) {
        window.wp = {};
    }

    if ( 'undefined' === wp.i18n ) {
        /* global wp, pwsL10n, wc_password_strength_meter_params */

        wp.passwordStrength = {
            /**
             * Determines the strength of a given password.
             *
             * Compares first password to the password confirmation.
             *
             * @since 3.7.0
             *
             * @param {string} password1       The subject password.
             * @param {Array}  disallowedList An array of words that will lower the entropy of
             *                                 the password.
             * @param {string} password2       The password confirmation.
             *
             * @return {number} The password strength score.
             */
            meter : function( password1, disallowedList, password2 ) {
                if ( ! Array.isArray( disallowedList ) )
                    disallowedList = [ disallowedList.toString() ];
    
                if (password1 != password2 && password2 && password2.length > 0)
                    return 5;
    
                if ( 'undefined' === typeof window.zxcvbn ) {
                    // Password strength unknown.
                    return -1;
                }
    
                var result = zxcvbn( password1, disallowedList );
                return result.score;
            },
    
            /**
             * Builds an array of words that should be penalized.
             *
             * Certain words need to be penalized because it would lower the entropy of a
             * password if they were used. The disallowedList is based on user input fields such
             * as username, first name, email etc.
             *
             * @since 3.7.0
             * @deprecated 5.5.0 Use {@see 'userInputDisallowedList()'} instead.
             *
             * @return {string[]} The array of words to be disallowed.
             */
            userInputBlacklist : function() {
                window.console.log(
                    sprintf(
                        /* translators: 1: Deprecated function name, 2: Version number, 3: Alternative function name. */
                        __( '%1$s is deprecated since version %2$s! Use %3$s instead. Please consider writing more inclusive code.' ),
                        'wp.passwordStrength.userInputBlacklist()',
                        '5.5.0',
                        'wp.passwordStrength.userInputDisallowedList()'
                    )
                );
    
                return wp.passwordStrength.userInputDisallowedList();
            },
    
            /**
             * Builds an array of words that should be penalized.
             *
             * Certain words need to be penalized because it would lower the entropy of a
             * password if they were used. The disallowed list is based on user input fields such
             * as username, first name, email etc.
             *
             * @since 5.5.0
             *
             * @return {string[]} The array of words to be disallowed.
             */
            userInputDisallowedList : function() {
                var i, userInputFieldsLength, rawValuesLength, currentField,
                    rawValues       = [],
                    disallowedList  = [],
                    userInputFields = [ 'user_login', 'first_name', 'last_name', 'nickname', 'display_name', 'email', 'url', 'description', 'weblog_title', 'admin_email' ];
    
                // Collect all the strings we want to disallow.
                rawValues.push( document.title );
                rawValues.push( document.URL );
    
                userInputFieldsLength = userInputFields.length;
                for ( i = 0; i < userInputFieldsLength; i++ ) {
                    currentField = jQuery( '#' + userInputFields[ i ] );
    
                    if ( 0 === currentField.length ) {
                        continue;
                    }
    
                    rawValues.push( currentField[0].defaultValue );
                    rawValues.push( currentField.val() );
                }
    
                /*
                 * Strip out non-alphanumeric characters and convert each word to an
                 * individual entry.
                 */
                rawValuesLength = rawValues.length;
                for ( i = 0; i < rawValuesLength; i++ ) {
                    if ( rawValues[ i ] ) {
                        disallowedList = disallowedList.concat( rawValues[ i ].replace( /\W/g, ' ' ).split( ' ' ) );
                    }
                }
    
                /*
                 * Remove empty values, short words and duplicates. Short words are likely to
                 * cause many false positives.
                 */
                disallowedList = jQuery.grep( disallowedList, function( value, key ) {
                    if ( '' === value || 4 > value.length ) {
                        return false;
                    }
    
                    return jQuery.inArray( value, disallowedList ) === key;
                });
    
                return disallowedList;
            }
        };
    
        // Backward compatibility.
    
        /**
         * Password strength meter function.
         *
         * @since 2.5.0
         * @deprecated 3.7.0 Use wp.passwordStrength.meter instead.
         *
         * @global
         *
         * @type {wp.passwordStrength.meter}
         */
        window.passwordStrength = wp.passwordStrength.meter;

        /**
         * Password Strength Meter class.
         */
        var wc_password_strength_meter = {

            /**
             * Initialize strength meter actions.
             */
            init: function() {
                Array.from( document.querySelectorAll( 'form.checkout #account_password' ) ).forEach( function( password ) {
                    password.addEventListener( 'keyup', wc_password_strength_meter.strengthMeter );
                } );
            },

            /**
             * Strength Meter.
             */
            strengthMeter: function() {
                var wrapper       = jQuery( 'form.register, form.checkout, form.edit-account, form.lost_reset_password' ),
                    submit        = jQuery( 'button[type="submit"]', wrapper ),
                    field         = jQuery( '#reg_password, #account_password, #password_1', wrapper ),
                    strength      = 1,
                    fieldValue    = field.val(),
                    stop_checkout = ! wrapper.is( 'form.checkout' ); // By default is disabled on checkout.

                wc_password_strength_meter.includeMeter( wrapper, field );

                strength = wc_password_strength_meter.checkPasswordStrength( wrapper, field );

                // Allow password strength meter stop checkout.
                if ( wc_password_strength_meter_params.stop_checkout ) {
                    stop_checkout = true;
                }

                if (
                    fieldValue.length > 0 &&
                    strength < wc_password_strength_meter_params.min_password_strength &&
                    -1 !== strength &&
                    stop_checkout
                ) {
                    submit.attr( 'disabled', 'disabled' ).addClass( 'disabled' );
                } else {
                    submit.prop( 'disabled', false ).removeClass( 'disabled' );
                }
            },

            /**
             * Include meter HTML.
             *
             * @param {Object} wrapper
             * @param {Object} field
             */
            includeMeter: function( wrapper, field ) {
                var meter = wrapper.find( '.woocommerce-password-strength' );

                if ( '' === field.val() ) {
                    meter.hide();
                    jQuery( document.body ).trigger( 'wc-password-strength-hide' );
                } else if ( 0 === meter.length ) {
                    field.after( '<div class="woocommerce-password-strength" aria-live="polite"></div>' );
                    jQuery( document.body ).trigger( 'wc-password-strength-added' );
                } else {
                    meter.show();
                    jQuery( document.body ).trigger( 'wc-password-strength-show' );
                }
            },

            /**
             * Check password strength.
             *
             * @param {Object} field
             *
             * @return {Int}
             */
            checkPasswordStrength: function( wrapper, field ) {
                var meter     = wrapper.find( '.woocommerce-password-strength' ),
                    hint      = wrapper.find( '.woocommerce-password-hint' ),
                    hint_html = '<small class="woocommerce-password-hint">' + wc_password_strength_meter_params.i18n_password_hint + '</small>',
                    strength  = wp.passwordStrength.meter( field.val(), wp.passwordStrength.userInputDisallowedList() ),
                    error     = '';

                // Reset.
                meter.removeClass( 'short bad good strong' );
                hint.remove();

                if ( meter.is( ':hidden' ) ) {
                    return strength;
                }

                // Error to append
                if ( strength < wc_password_strength_meter_params.min_password_strength ) {
                    error = ' - ' + wc_password_strength_meter_params.i18n_password_error;
                }

                switch ( strength ) {
                    case 0 :
                        meter.addClass( 'short' ).html( pwsL10n['short'] + error );
                        meter.after( hint_html );
                        break;
                    case 1 :
                        meter.addClass( 'bad' ).html( pwsL10n.bad + error );
                        meter.after( hint_html );
                        break;
                    case 2 :
                        meter.addClass( 'bad' ).html( pwsL10n.bad + error );
                        meter.after( hint_html );
                        break;
                    case 3 :
                        meter.addClass( 'good' ).html( pwsL10n.good + error );
                        break;
                    case 4 :
                        meter.addClass( 'strong' ).html( pwsL10n.strong + error );
                        break;
                    case 5 :
                        meter.addClass( 'short' ).html( pwsL10n.mismatch );
                        break;
                }

                return strength;
            }
        };

        wc_password_strength_meter.init();
    }
};

export default fluxCompatibility;